module.exports = __webpack_public_path__ + "img/icon_mymachine.2395538f.svg";